import * as yup from "yup";
import { MSG } from "../constants/MSG";

export const createPayoutsSchema = yup.object().shape({
	stripe_amount: yup
		.string()
		.trim()
		.matches(
			new RegExp(/^(?:100|\d{1,10})(?:\.\d{1,2})?$/),
			MSG.REQUIRED_VALID_AMOUNT
		)
		.required(MSG.REQUIRED_AMOUNT)
		.test("Is positive?", MSG.AMOUNT_GREATER_THAN_ZERO, (value) => value > 0),
});
